import { EOrderStatus, IOrder, OrderStatus } from '../../types/order'
import { Tag } from '../Tag'
import { SHIPPING_STATUS } from '../../constants/shipping-status'

interface IOrderTagProps {
  order?: IOrder
  status: EOrderStatus
}

const OrderTag = (prop: IOrderTagProps) => {
  const { status, order } = prop
  const orderTag: any = OrderStatus[status]

  // const lists = SHIPPING_STATUS.find((item) => item.provider === order?.trackingProvider)
  // let statusName = ''
  // if (lists) {
  //   const s = lists.status.find((item) => item.code.toString() === order?.providerStatus)
  //   if (s) {
  //     statusName = s?.name
  //   }
  // }

  return (
    <>
      <Tag color={orderTag.color}>{orderTag.label}</Tag>
      {/*{statusName ? (*/}
      {/*    <Tag color={`success`}>*/}
      {/*      {statusName}*/}
      {/*    </Tag>*/}
      {/*  ) :*/}
      {/*  <Tag color={orderTag.color}>{orderTag.label}</Tag>*/}
      {/*}*/}
    </>
  )
}

export default OrderTag
